import { mobileMenuToggle } from '../../src/js/events';

export default class MobileMenu {
  constructor() {
    window.addEventListener(mobileMenuToggle, this.toggle.bind(this));
    window.addEventListener('resize', this.onResize.bind(this));

    this.$el = document.getElementById('mobile-menu');
    this.activeClass = 'is-active';
    this.active = this.$el.classList.contains(this.activeClass);

    this.$listItems = this.$el.querySelectorAll('.js-mobile-menu-item');

    this.$listItems.forEach($item => {
      const $link = $item.querySelector('.js-mobile-menu-item-link');
      const $subMenu = $item.querySelector('.js-mobile-menu-sub-menu');

      if ($subMenu) {
        $link.addEventListener('click', (e) => {
          e.preventDefault();
          this.onParentButtonClick($link, $subMenu)
        });
      }
    });
  }

  /**
   * @function toggle
   * Toggles the mobile menu
   */
  toggle() {
    this.active = !this.active;

    this.$el.classList.toggle(this.activeClass, this.active);
    this.$el.setAttribute('aria-hidden', !this.active);

    document.body.classList.toggle('scrolling-disabled', this.active);
  }

  /**
   * @function onResize
   * Hides the mobile menu if resizing the browser
   * beyond mobile when the mobile menu is active
   */
  onResize() {
    const { lg } = { lg: '1024px' }; // tailwind.theme.screens;
    const size = parseInt(lg.substring(0, lg.length - 2));

    if (window.innerWidth >= size && this.active) {
      this.toggle();
    }
  }

  /**
   * @function onParentButtonClick
   * @param {HTMLAnchorElement} $link
   * @param {HTMLUListElement} $subMenu
   * Toggles the sub menu of a parent element
   */
  onParentButtonClick($link, $subMenu) {
    const $listItem = $link.parentElement;
    $listItem.classList.toggle(this.activeClass);
    $subMenu.setAttribute('aria-hidden', !$listItem.classList.contains(this.activeClass));
  }
}
